import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import { IMeetingConnectionRequestParams } from '../connections.dao';
import {
    ICreateMeetingLinkRequest,
    IMeetingLinkDTO,
    IMeetingLinksDAO,
    IMeetingLinksListDTO,
    IUpdateMeetingLinkRequest,
} from '../meeting-links.dao';
import { MEETING_LINK_URL, MEETING_LINKS_URL } from '../../constants/api/meetings-api.constants';

class MeetingLinksDAO extends IMeetingLinksDAO {
    constructor(
        @IoC.Inject private readonly apiClient: IApiClient
    ) {
        super();
    }

    public async getMeetingLinks(params: IMeetingConnectionRequestParams): Promise<IMeetingLinkDTO[]> {
        const response = await this.apiClient.get<IMeetingLinkDTO[] | IMeetingLinksListDTO>(MEETING_LINKS_URL, params);
        return MeetingLinksDAO.normalizeList(response.parsedResponse);
    }

    public async createMeetingLink(
        params: IMeetingConnectionRequestParams & ICreateMeetingLinkRequest
    ): Promise<IMeetingLinkDTO> {
        const response = await this.apiClient.post<IMeetingLinkDTO>(MEETING_LINKS_URL, params);
        return response.parsedResponse;
    }

    public async updateMeetingLink(
        params: IMeetingConnectionRequestParams & IUpdateMeetingLinkRequest
    ): Promise<IMeetingLinkDTO> {
        const response = await this.apiClient.put<IMeetingLinkDTO>(MEETING_LINK_URL, params);
        return response.parsedResponse;
    }

    private static normalizeList(payload: IMeetingLinkDTO[] | IMeetingLinksListDTO | undefined): IMeetingLinkDTO[] {
        if (Array.isArray(payload)) {
            return payload;
        }
        return payload?.meetingLinks ?? [];
    }
}

export { MeetingLinksDAO };
